import * as React from 'react';
import { Link, RouteComponentProps, Redirect } from 'react-router-dom';
//import { RouteComponentProps } from 'react-router';
import * as Session from '../service/Session';
import * as RB from 'react-bootstrap';
import * as DTO from '../service/DTOs';
import Cleave from 'cleave.js/react';
import * as API from '../service/apisvc';
import moment from 'moment';

import { SpinnerBlock } from './shared/effects/Spinners'
const iconSpinner = <SpinnerBlock />


type PersonProfileProps = RouteComponentProps<{}> & { xsrfToken?: string };

interface PersonProfileState {
    helpCtxId: string;
    user: Session.UserState;
    form?: DTO.ProfileSettings;
    isSubmitting?: boolean;
    submitted?: boolean;
    result?: string;
    result_is_ok?: boolean;
    loading: boolean;
}

const initialForm: DTO.ProfileSettings = {
    idperson: 0,
    disconnectProcess: 'none',
    disconnectTimeoutSpan: undefined,
    disconnectTimeoutSpan_str: ''
}


export class PersonProfile extends React.Component<PersonProfileProps, PersonProfileState> {
    constructor(props: PersonProfileProps) {
        super(props);
        let _user = this.masterStateRestore();

        //this.state = { helpCtxId: '', user: { identityState: Session.AnonimousIdentityState } };
        this.state = { helpCtxId: '', loading: false, ..._user };
    }

    masterStateRestore() {
        let _user = Session.currentUser();
        if (_user)
            return { user: _user };
        else
            return { user: { identityState: Session.AnonimousIdentityState } };
    }

    componentDidMount() {
        this.readProfile();
    }

    readProfile() {
        if (this.state.user && this.state.user.personalState) {
            this.setState({ loading: true });
            fetch(API.apiUrl(API.API_PROFILE_URL + '/' + this.state.user.personalState.idperson), {
                method: 'GET',
                credentials: 'include',
                headers: new Headers({
                    ...{ 'X-XSRF-TOKEN': this.props.xsrfToken || '' },
                    ...API.authHeader()
                })
            })
                .then(response => {
                    if (response.ok) {
                        return response.json() as Promise<DTO.ProfileSettings>
                    } else {
                        var error = new Error(response.statusText);
                        throw error;
                    }
                }
                )
                .then(data => {

                    if (data.disconnectTimeoutSpan) {
                        data.disconnectTimeoutSpan_str = moment(data.disconnectTimeoutSpan).utc().format('HHmmss');
                        data.disconnectTimeoutSpan = moment(data.disconnectTimeoutSpan_str, "HHmmss", true).toDate();
                    }
                    else
                        data.disconnectTimeoutSpan_str = '';

                    this.setState({ form: data, loading: false });
                })
                .catch(reason => {
                    //console.log('readProfile error');
                    //console.log(reason);
                    this.setState({ form: initialForm, loading: false });
                })
                ;
        }
    }

    //componentWillReceiveProps(nextProps: PersonProfileProps) {
    //    this.setState({ user: nextProps.user });
    //}


    submit = (event: React.FormEvent<RB.Form>) => {
        if (this.state.form) {
            this.submitSettingsForm(this.state.form);
            event.preventDefault();
        }
    }


    checkDisconnect(form?: DTO.ProfileSettings): DTO.ProfileSettings | undefined {
        if (form) {
            let time = form.disconnectTimeoutSpan_str.substr(0, 2) + ":" + form.disconnectTimeoutSpan_str.substr(2, 2) + ":" + form.disconnectTimeoutSpan_str.substr(4);
            let timeok = moment(time, "HH:mm:ss", true).isValid();

            let timespantime = undefined;
            if (timeok)
                timespantime = moment(time, "HH:mm:ss", true).toDate();

            return { ...form, ...{ disconnectTimeoutSpan: timespantime } };
        }
        else
            return form;

    }

    handleChange = (e: any) => {
        if (this.state.form) {
            var _form = { ...this.state.form, ...e.target.hasOwnProperty('rawValue') ? { [e.target.name]: e.target.rawValue } : { [e.target.name]: e.target.value } };

            this.setState({ form: this.checkDisconnect(_form) });
        }
    }


    handleDisconnectProcessChange(eventKey: any) {
        if (this.state.form) {
            var _form = this.state.form;

            _form.disconnectProcess = eventKey;

            this.setState({ form: _form });
        }
    }


    dispatch(action: ProfileAction) {
        let nstate: any = stateforwarder(this.state, action);
        if ('form' in nstate && nstate.form != this.state.form) {
            //const { ..._form }: DTO.NewNotesOrder | undefined = this.check__(nstate.form);
            const { ..._form }: DTO.NewNotesOrder | undefined = nstate.form;
            const { ..._state } = { ...this.state, ...nstate, ...{ form: _form } };

            this.setState({ ..._state });
        }
        else
            this.setState({ ...this.state, ...nstate });
    }

    submitSettingsForm = (form: DTO.ProfileSettings) => {
        //this.hideAllPopovers();

        return (async () => {
            this.dispatch({ type: 'SUBMIT_NEW_PROFILE_FORM', payload: form });

            try {
                const xsrf = this.props.xsrfToken;
                const response: Response = await fetch(API.apiUrl(API.API_PROFILE_URL), {
                    method: 'POST',
                    credentials: 'include',
                    headers: new Headers({
                        ...
                        {
                            'Content-Type': 'application/json',
                            'X-XSRF-TOKEN': xsrf || ''
                        },
                        ...API.authHeader()
                    }),
                    body: JSON.stringify(form)
                });

                const statusCode = response.status;
                //console.log(statusCode);
                if (statusCode === 201) {
                    const data = await response.json() as DTO.MessageDto<DTO.ProfileSettings>;
                    //this.props.onProfileSubmitted ? this.props.onProfileSubmitted(data.result) : '';

                    this.dispatch({ type: 'NEW_PROFILE_RECIEVED', payload: { form: data.result, result: 'Настройки сохранены' } });

                    setTimeout(() => {
                        this.dispatch({ type: 'RESET_NEW_PROFILE_FORM' });
                    }, 2000);
                }
                else if (statusCode === 422) {
                    let err = await response.json() as { personProfileDto: string[] };

                    this.dispatch({ type: 'NEW_PROFILE_FORM_ERROR', payload: { form, errors: err.personProfileDto, result: 'Введенные данные некорректны' } });
                }
                else {
                    let err = await response.json() as { personProfileDto: string[] };

                    this.dispatch({ type: 'NEW_PROFILE_FORM_ERROR', payload: { form, errors: err.personProfileDto, result: response.statusText } });
                }
            } catch (error) {
                //alert(error);
                this.dispatch({ type: 'NEW_PROFILE_FORM_ERROR', payload: { form, errors: undefined, result: error.message || 'Произошла ошибка' } });
            }

        })();
    }

    public render() {
        let userInfo = undefined;
        let actionsWell = undefined;
        let settingsForm = undefined;
        if (this.state.user.personalState) {
            let ps = this.state.user.personalState;
            userInfo = <div>
                <span><b>Профиль пользователя</b></span>
                <table className='table table-condensed' style={{ width: '500px' }} >
                    <tbody>
                        <tr>
                            <td style={{ textAlign: 'right' }}>{'Фамилия: '}</td>
                            <td>{ps.lastName}</td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'right' }}>{'Имя: '}</td>
                            <td>{ps.firstName}</td>
                        </tr>

                        <tr>
                            <td style={{ textAlign: 'right' }}>{'Отчество: '}</td>
                            <td>{ps.sureName}</td>
                        </tr>

                        <tr>
                            <td style={{ textAlign: 'right' }}>{'Телефон: '}</td>
                            <td>{ps.phoneNumber}</td>
                        </tr>

                        <tr>
                            <td style={{ textAlign: 'right' }}>{'Email: '}</td>
                            <td>{ps.email}</td>
                        </tr>

                        <tr>
                            <td style={{ textAlign: 'right' }}>{'Контактная информация: '}</td>
                            <td>{ps.contactInfo}</td>
                        </tr>
                    </tbody>
                </table>

            </div>;

            actionsWell = <div className="otc-order-entrance" >
                <RB.Row>
                    <RB.Col sm={12}>
                        <RB.Well bsSize="sm" style={{ marginTop: '10px', position: 'relative', maxWidth: '500px', minHeight: '100px' }} className="otc-order-entrance-well">
                            <RB.ButtonToolbar className={'rep_welltitle'}>
                                <RB.ButtonGroup bsSize="xsmall">
                                    <div><b>Операции</b></div>
                                </RB.ButtonGroup>
                            </RB.ButtonToolbar>

                            <RB.Form horizontal method="post" onSubmit={this.submit} autoComplete="off" style={{ marginTop: '5px' }}>
                                <fieldset>
                                    <h5><Link to={'/chpassword'}>Сменить пароль</Link></h5>
                                </fieldset>
                            </RB.Form>

                        </RB.Well>
                    </RB.Col>
                </RB.Row>
            </div>;


            if (this.state.form) {
                let disconnectType = this.state.form.disconnectProcess;

                let disconnectTypeValid = disconnectType == 'none' || (disconnectType == 'droporders' && this.state.form.disconnectTimeoutSpan) || (this.state.submitted && !this.state.result_is_ok);

                let disconnectValidMark = !disconnectTypeValid ?
                    <RB.InputGroup.Addon style={{ minWidth: '5px', cursor: 'help' }} title={"Некорректный временной интервал"}><RB.Glyphicon glyph="warning-sign" /></RB.InputGroup.Addon>
                    : <RB.InputGroup.Addon><RB.Glyphicon glyph="time" /></RB.InputGroup.Addon>;

                let disconnectSpanSelector = disconnectType == 'droporders' ?
                    <RB.InputGroup>
                        <Cleave className="form-control input-numeral" style={{ maxWidth: '100px' }} name="disconnectTimeoutSpan_str" value={this.state.form.disconnectTimeoutSpan_str} placeholder="hh:mm:ss" options={{ time: true, timePattern: ['h', 'm', 's'] }} onChange={this.handleChange} />
                        {disconnectValidMark}
                    </RB.InputGroup>
                    //</RB.ButtonGroup >
                    : undefined;

                let submitEnabled = true;
                let btnSubmit = <RB.Button style={{ float: 'right' }} type="submit" bsSize="sm" bsStyle="primary" disabled={!submitEnabled}>{'Сохранить'}</RB.Button>;

                let resultCap =
                    this.state.isSubmitting ?
                        <div>{"Отправка данных"}</div>
                        : this.state.submitted ?
                            (this.state.result_is_ok === undefined ? ""
                                : this.state.result_is_ok ?
                                    <div><RB.Glyphicon glyph="glyphicon glyphicon-ok" />{" "}{this.state.result}</div>
                                    : <div><RB.Glyphicon glyph="glyphicon glyphicon-exclamation-sign" />{" "}{this.state.result}</div>
                            )
                            : "";

                let hdrContent = <div><b>Пользовательские настройки</b></div>
                var wellTitleClass = 'rep_welltitle';


                settingsForm = <div className="otc-order-entrance" >
                    <RB.Row>
                        <RB.Col sm={12}>
                            <RB.Well bsSize="sm" style={{ marginTop: '10px', position: 'relative', maxWidth: '500px', minHeight: '200px' }} className="otc-order-entrance-well">
                                <RB.ButtonToolbar className={wellTitleClass}>
                                    <RB.ButtonGroup bsSize="xsmall">
                                        {hdrContent}
                                    </RB.ButtonGroup>
                                </RB.ButtonToolbar>

                                <RB.Form horizontal method="post" onSubmit={this.submit} autoComplete="off" style={{ marginTop: '5px' }}>
                                    <input type="hidden" name="requestVerificationToken" defaultValue={this.props.xsrfToken} />
                                    <fieldset>
                                        <RB.FormGroup validationState={disconnectTypeValid ? undefined : "warning"}>
                                            <RB.Col sm={4} className='otc-inp-label'>
                                                {'Автоснятие заявок по разрыву связи:'}
                                            </RB.Col>

                                            <RB.Col sm={8}>
                                                <RB.InputGroup
                                                    type="radio"
                                                    name="withdrawtype"
                                                    id="withdrawtype"
                                                    value={disconnectType}
                                                >
                                                    <div className="input-group">
                                                        <span className="input-group-btn">
                                                            <button className={'btn ' + (disconnectType == 'none' ? 'btn-success' : 'btn-default')} type="button" value={"none"} onClick={this.handleDisconnectProcessChange.bind(this, 'none')} >Нет</button>
                                                        </span>
                                                        <span className="input-group-btn">
                                                            <button className={'btn ' + (disconnectType == 'droporders' ? 'btn-success' : 'btn-default')} type="button" value={"droporders"} onClick={this.handleDisconnectProcessChange.bind(this, 'droporders')}>Через</button>
                                                        </span>
                                                        {disconnectSpanSelector}
                                                    </div>
                                                </RB.InputGroup>
                                            </RB.Col>
                                        </RB.FormGroup>

                                        <hr />
                                        <RB.FormGroup >
                                            <RB.Col sm={1}>
                                                {''}
                                            </RB.Col>

                                            <RB.Col sm={3} className="text-center">
                                                {btnSubmit}
                                                {/*this.props.tradesession && this.props.tradesession.isopen ?
                                                <RB.Button style={{ float: 'right' }} type="submit" bsSize="sm" bsStyle="primary" disabled={this.state.isSubmitting || !this.state.selectedSec}>{buyCaption}</RB.Button>
                                                : undefined
                                            */}
                                            </RB.Col>
                                            <RB.Col sm={8}>
                                                {''}
                                            </RB.Col>
                                        </RB.FormGroup>
                                        <hr />
                                        <RB.FormGroup>
                                            <RB.Col sm={12} className="text-center">

                                                <div>
                                                    {resultCap}
                                                </div>
                                            </RB.Col>
                                        </RB.FormGroup>


                                    </fieldset>
                                </RB.Form>
                            </RB.Well>
                        </RB.Col>
                    </RB.Row>
                </div>
            }
            else
                settingsForm = undefined;
        }


        return <div className="otc-trade">
            <h3>Профиль пользователя</h3>
            <hr />
            {userInfo}
            {actionsWell}
            {
                this.state.loading ?
                    <div>{iconSpinner}</div>
                    :
                    <div>{settingsForm}</div>
            }

        </div>
            ;
    }
}

interface SubmitProfileFormAction {
    type: 'SUBMIT_NEW_PROFILE_FORM'
    payload: DTO.ProfileSettings
}

interface ProfileFormRecievedAction {
    type: 'NEW_PROFILE_RECIEVED',
    payload: {
        form: DTO.ProfileSettings;
        result: string;
    }
}

interface ResetProfileFormAction {
    type: 'RESET_NEW_PROFILE_FORM'
}


interface ProfileFormErrorAction {
    type: 'NEW_PROFILE_FORM_ERROR',
    payload: {
        form: DTO.ProfileSettings,
        errors: string[] | undefined,
        result: string;
    }
}

type ProfileAction = SubmitProfileFormAction | ProfileFormRecievedAction | ResetProfileFormAction | ProfileFormErrorAction;

const stateforwarder = (state: PersonProfileState, action: ProfileAction) => {
    switch (action.type) {
        case 'SUBMIT_NEW_PROFILE_FORM':
            //console.log('do SUBMIT_NEW_PROFILE_FORM');
            return {
                form: action.payload,
                isSubmitting: true,
                submitted: false,
                result_is_ok: undefined
            };
        case 'NEW_PROFILE_RECIEVED':
            //console.log('do NEW_PROFILE_RECIEVED');
            return {
                //form: initialForm,
                isSubmitting: false,
                submitted: true,
                result_is_ok: true,
                result: action.payload.result
            };
        case 'NEW_PROFILE_FORM_ERROR':
            return {
                form: action.payload.form,
                isSubmitting: false,
                submitted: true,
                result_is_ok: false,
                result: action.payload.errors ? (action.payload.errors.length > 0 ? action.payload.errors[0] : action.payload.result) : action.payload.result
            };
        case 'RESET_NEW_PROFILE_FORM':
            return {
                isSubmitting: false,
                submitted: false,
                result: '',
                result_is_ok: undefined
            };
        default:
            const exhaustiveCheck: never = action;
    }

    return state;
};




//import * as React from 'react';
//import { Link, RouteComponentProps, Redirect } from 'react-router-dom';
////import { RouteComponentProps } from 'react-router';
//import * as Session from '../service/Session';
//import * as RB from 'react-bootstrap';

//import * as API from '../service/apisvc';


//type PersonProfileProps = RouteComponentProps<{}>;

//interface PersonProfileState {
//    helpCtxId: string;
//    user: Session.UserState;    
//}

//export class PersonProfile extends React.Component<RouteComponentProps<{}>, PersonProfileState> {
//    constructor(props: RouteComponentProps<{}> ) {
//        super(props);
//        let _user = this.masterStateRestore();

//        //this.state = { helpCtxId: '', user: { identityState: Session.AnonimousIdentityState } };
//        this.state = { helpCtxId: '', ..._user };        
//    }

//    masterStateRestore() {
//        let _user = API.currentUser();
//        if (_user)
//            return { user: _user };
//        else
//            return { user: { identityState: Session.AnonimousIdentityState } };
//    }

//    //componentWillReceiveProps(nextProps: PersonProfileProps) {
//    //    this.setState({ user: nextProps.user });
//    //}

//    public render() {
//        let userInfo = undefined;
//        if (this.state.user.personalState) {
//            let ps = this.state.user.personalState;
//            userInfo = <div>
//                <span><b>Профиль пользователя</b></span>
//                <table className='table table-condensed' style={{width: '300px'}} >
//                        <tbody>
//                            <tr>
//                                <td style={{ textAlign: 'right' }}>{'Фамилия: '}</td>
//                                <td>{ps.lastName}</td>
//                            </tr>
//                            <tr>
//                                <td style={{ textAlign: 'right' }}>{'Имя: '}</td>
//                                <td>{ps.firstName}</td>
//                            </tr>

//                        <tr>
//                            <td style={{ textAlign: 'right' }}>{'Отчество: '}</td>
//                            <td>{ps.sureName}</td>
//                        </tr>

//                        <tr>
//                            <td style={{ textAlign: 'right' }}>{'Телефон: '}</td>
//                            <td>{ps.phoneNumber}</td>
//                        </tr>

//                        <tr>
//                            <td style={{ textAlign: 'right' }}>{'Email: '}</td>
//                            <td>{ps.email}</td>
//                        </tr>

//                        <tr>
//                            <td style={{ textAlign: 'right' }}>{'Контактная информация: '}</td>
//                            <td>{ps.contactInfo}</td>
//                        </tr>
//                        </tbody>
//                </table>

//                <h5><Link to={'/chpassword'}>Сменить пароль</Link></h5>

//                </div>;

//        }

//        return <div>
//            <h3>Профиль пользователя</h3>
//            <hr/>
//            {userInfo}
//        </div>;
//    }
//}
